/* eslint-disable class-methods-use-this */
import {
  updateDocSignatoryActionV2,
  deleteDOCSignerTags,
  createDocSignerIdentityAction,
} from "../../../actions/DocumentActions";
import { updateToolPaneData } from "../../../actions/QuotationActions/QuotationActions";
import { TOOLPANE_TTITLE } from "../../../constants/toolpane";

import store from "../../../store";
import AddDocComponentCommand from "../addComponentCommandBase/addDocComponentCommand";

class AddSignatureDocCommand extends AddDocComponentCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  addTagWithComponent(docID, data, componentPayload) {
    store.dispatch(updateDocSignatoryActionV2(docID, [data])).then(() => {
      super
        .saveToDatabase(componentPayload)
        .then(() => {
          store.dispatch(
            updateToolPaneData(
              true,
              TOOLPANE_TTITLE.DOC_SIGNATURE_COMPONENTS,
              this.componentData.mode,
            ),
          );
        })
        .catch(() => {
          this.deleteSignerTags();
        });
    });
  }

  execute() {
    if (this.isRedo) {
      super.redo();
      const { docID } = this.componentData;
      const componentPayload = super.getComponentPayload();
      store.dispatch(
        updateDocSignatoryActionV2(docID, [
          componentPayload.component.content.data,
        ]),
      );
    } else {
      const { docID } = this.componentData;
      // 1.
      super.prepareLayout();
      // 2.
      const activeEditorPayload = this.getActiveEditorPayload();
      // 3.
      super.updateRedux(activeEditorPayload);
      const componentPayload = super.getComponentPayload();
      const {
        component: {
          content: { data },
        },
      } = componentPayload;
      const { signer_identity_id } = data;
      // When added from blocks pane or plus button, signatory identity is present as it is not created
      // Create signer identity and then make add component and add tag to signatory api/action call
      if (signer_identity_id) {
        this.addTagWithComponent(docID, data, componentPayload);
      } else {
        store.dispatch(createDocSignerIdentityAction(docID)).then(res => {
          data.signer_identity_id = res.id;
          this.addTagWithComponent(docID, data, componentPayload);
        });
      }
    }
  }

  deleteSignerTags() {
    const { sectionID, docID, component } = this.componentData;
    const deleteSignatureTagPayload = {
      component_id: sectionID,
      ids: [component.data.id],
    };
    store.dispatch(deleteDOCSignerTags(docID, deleteSignatureTagPayload));
  }

  undo() {
    super.undo();
    this.deleteSignerTags();
  }
}

export default AddSignatureDocCommand;
